export default {
      id: "icon_sad_smile-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#icon_sad_smile",
      toString: function () {
        return this.url;
      }
    }